import { z } from "zod";
import { shareLinkFor } from "../share";
/**
 * Personal invites (`D275`): the wire. Attribution only — no money, no
 * reward, no ranking.
 *
 * - `GET /me/invite` — the caller's code (`null` until made) and how many
 *   accounts came by it. Never who.
 * - `PUT /me/invite` — make the caller's code if there is none; idempotent.
 * - `POST /me/invite/redeem` — credit the code's owner with the caller's
 *   account: once, within 14 days of creating it, never one's own.
 *
 * Before launch the invite is the CODE in the share text; once `D257`'s
 * switch names a base, the text also carries `<base>?ref=<ref>&invite=<code>`
 * — the site keeps the code on the device, and the app redeems it once after
 * sign-in.
 */
export const INVITE_ROUTES = {
    mine: "/me/invite",
    redeem: "/me/invite/redeem",
};
/** The query key an invite link carries its code under. */
export const INVITE_PARAM = "invite";
/** Eight characters of Crockford base 32 today; 6 to 16 accepted. */
export const inviteCode = z.string().regex(/^[0-9a-z]{6,16}$/);
export const myInviteOutput = z.object({
    code: inviteCode.nullable(),
    invitedCount: z.int().nonnegative(),
});
/** `POST /me/invite/redeem`. Strict, like every input (`D172`). */
export const redeemInviteInput = z.strictObject({ code: inviteCode });
export const redeemInviteOutput = z.object({ redeemed: z.literal(true) });
/** Read as a person types it: case, spaces and dashes ignored, `o` as 0
 *  and `i`/`l` as 1 (Crockford). `null` when it cannot be a code. */
export function parseInviteCode(typed) {
    const cleaned = typed
        .toLowerCase()
        .replace(/[\s-]/g, "")
        .replace(/[il]/g, "1")
        .replace(/o/g, "0");
    const parsed = inviteCode.safeParse(cleaned);
    if (!parsed.success || cleaned.includes("u")) {
        return null;
    }
    return parsed.data;
}
/** `abcd2345` → `ABCD 2345`. */
export function formatInviteCode(code) {
    return (code.toUpperCase().match(/.{1,4}/g) ?? []).join(" ");
}
/** An invite link, with `D260`'s per-share ref when there is one. */
export function inviteLinkFor(base, code, ref) {
    const url = new URL(ref === null ? base : shareLinkFor(base, ref));
    url.searchParams.set(INVITE_PARAM, code);
    return url.toString();
}
//# sourceMappingURL=invite.js.map